import React from 'react';
import { SectionReveal } from '../components/SectionReveal';
import { StarIcon } from 'lucide-react';
function Stars() {
  return <div className="flex gap-1 mb-3" aria-label="5 estrellas" data-id="element-256">
      <StarIcon className="w-5 h-5 text-[#f59e0b] fill-[#f59e0b]" data-id="element-257" />
      <StarIcon className="w-5 h-5 text-[#f59e0b] fill-[#f59e0b]" data-id="element-258" />
      <StarIcon className="w-5 h-5 text-[#f59e0b] fill-[#f59e0b]" data-id="element-259" />
      <StarIcon className="w-5 h-5 text-[#f59e0b] fill-[#f59e0b]" data-id="element-260" />
      <StarIcon className="w-5 h-5 text-[#f59e0b] fill-[#f59e0b]" data-id="element-261" />
    </div>;
}
function Avatar({
  initials,
  color
}: {
  initials: string;
  color: string;
}) {
  return <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 font-heading font-bold text-white text-lg ${color}`} data-id="element-262">
      {initials}
    </div>;
}
export function TestimonialsSection() {
  return <section className="relative w-full bg-brand-darker py-20 md:py-28 overflow-hidden" data-id="element-263">
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-blue-500/20 to-transparent" data-id="element-264" />

      <div className="relative z-10 max-w-5xl mx-auto px-4" data-id="element-265">
        <SectionReveal data-id="element-266">
          <p className="text-4xl mb-4 text-center" data-id="element-267">👥</p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-white text-center mb-4 uppercase tracking-[-0.02em]" data-id="element-268">
            Miles de personas ya lo están aplicando para pagar menos.
          </h2>
          <p className="text-xl text-gray-400 font-body text-center mb-14" data-id="element-269">
            Porque el problema es el mismo en todas las casas.
          </p>
        </SectionReveal>

        {/* Metrics */}
        <SectionReveal delay={0.05} data-id="element-270">
          <div className="flex justify-center gap-12 mb-12 flex-wrap" data-id="element-271">
            <div className="text-center" data-id="element-272">
              <div className="text-[32px] font-black" style={{
              color: '#3b82f6'
            }} data-id="element-273">
                ⭐ 4.9
              </div>
              <div className="text-xs uppercase tracking-wider" style={{
              color: '#64748b'
            }} data-id="element-274">
                de 5 estrellas
              </div>
            </div>
            <div className="text-center" data-id="element-275">
              <div className="text-[32px] font-black" style={{
              color: '#3b82f6'
            }} data-id="element-276">
                +3.000
              </div>
              <div className="text-xs uppercase tracking-wider" style={{
              color: '#64748b'
            }} data-id="element-277">
                compradores
              </div>
            </div>
            <div className="text-center" data-id="element-278">
              <div className="text-[32px] font-black" style={{
              color: '#3b82f6'
            }} data-id="element-279">
                🇦🇷
              </div>
              <div className="text-xs uppercase tracking-wider" style={{
              color: '#64748b'
            }} data-id="element-280">
                toda Argentina
              </div>
            </div>
          </div>
        </SectionReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-281">
          {/* Testimonial 1 */}
          <SectionReveal delay={0.05} data-id="element-282">
            <div className="bg-[#1e293b] border border-[rgba(59,130,246,0.15)] rounded-xl p-6 h-full flex flex-col" style={{
            borderTop: '3px solid #3b82f6'
          }} data-id="element-283">
              <Stars data-id="element-284" />
              <p className="text-gray-300 font-body text-base leading-relaxed mb-5 flex-1 italic" data-id="element-285">
                "Mi factura bajó de $85.000 a $38.000. La guía es clara y fácil
                de seguir."
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-700/50" data-id="element-286">
                <Avatar initials="ML" color="bg-pink-600" data-id="element-287" />
                <div data-id="element-288">
                  <p className="text-white font-body font-semibold text-sm m-0" data-id="element-289">
                    María L.
                  </p>
                  <p className="text-gray-500 font-body text-xs m-0" data-id="element-290">
                    42 años, Córdoba
                  </p>
                </div>
              </div>
            </div>
          </SectionReveal>

          {/* Testimonial 2 */}
          <SectionReveal delay={0.1} data-id="element-291">
            <div className="bg-[#1e293b] border border-[rgba(59,130,246,0.15)] rounded-xl p-6 h-full flex flex-col" style={{
            borderTop: '3px solid #3b82f6'
          }} data-id="element-292">
              <Stars data-id="element-293" />
              <p className="text-gray-300 font-body text-base leading-relaxed mb-5 flex-1 italic" data-id="element-294">
                "Apliqué 3 consejos y ya noté el cambio. Muy recomendable."
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-700/50" data-id="element-295">
                <Avatar initials="CR" color="bg-blue-600" data-id="element-296" />
                <div data-id="element-297">
                  <p className="text-white font-body font-semibold text-sm m-0" data-id="element-298">
                    Carlos R.
                  </p>
                  <p className="text-gray-500 font-body text-xs m-0" data-id="element-299">
                    38 años, Rosario
                  </p>
                </div>
              </div>
            </div>
          </SectionReveal>

          {/* Testimonial 3 */}
          <SectionReveal delay={0.15} data-id="element-300">
            <div className="bg-[#1e293b] border border-[rgba(59,130,246,0.15)] rounded-xl p-6 h-full flex flex-col" style={{
            borderTop: '3px solid #3b82f6'
          }} data-id="element-301">
              <Stars data-id="element-302" />
              <p className="text-gray-300 font-body text-base leading-relaxed mb-5 flex-1 italic" data-id="element-303">
                "Soy jubilada y cada peso cuenta. Me ayudó a detectar errores de
                años."
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-700/50" data-id="element-304">
                <Avatar initials="LG" color="bg-purple-600" data-id="element-305" />
                <div data-id="element-306">
                  <p className="text-white font-body font-semibold text-sm m-0" data-id="element-307">
                    Luciana G.
                  </p>
                  <p className="text-gray-500 font-body text-xs m-0" data-id="element-308">
                    71 años, Buenos Aires
                  </p>
                </div>
              </div>
            </div>
          </SectionReveal>

          {/* Testimonial 4 */}
          <SectionReveal delay={0.2} data-id="element-309">
            <div className="bg-[#1e293b] border border-[rgba(59,130,246,0.15)] rounded-xl p-6 h-full flex flex-col" style={{
            borderTop: '3px solid #3b82f6'
          }} data-id="element-310">
              <Stars data-id="element-311" />
              <p className="text-gray-300 font-body text-base leading-relaxed mb-5 flex-1 italic" data-id="element-312">
                "Tengo un comercio. Ahorro más de $50.000 por mes."
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-700/50" data-id="element-313">
                <Avatar initials="FM" color="bg-emerald-600" data-id="element-314" />
                <div data-id="element-315">
                  <p className="text-white font-body font-semibold text-sm m-0" data-id="element-316">
                    Fernando M.
                  </p>
                  <p className="text-gray-500 font-body text-xs m-0" data-id="element-317">
                    45 años, Mendoza
                  </p>
                </div>
              </div>
            </div>
          </SectionReveal>

          {/* Testimonial 5 */}
          <SectionReveal delay={0.25} data-id="element-318">
            <div className="bg-[#1e293b] border border-[rgba(59,130,246,0.15)] rounded-xl p-6 h-full flex flex-col" style={{
            borderTop: '3px solid #3b82f6'
          }} data-id="element-319">
              <Stars data-id="element-320" />
              <p className="text-gray-300 font-body text-base leading-relaxed mb-5 flex-1 italic" data-id="element-321">
                "No necesitás saber nada técnico. En mi casa ya se nota la
                diferencia."
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-700/50" data-id="element-322">
                <Avatar initials="AP" color="bg-orange-600" data-id="element-323" />
                <div data-id="element-324">
                  <p className="text-white font-body font-semibold text-sm m-0" data-id="element-325">
                    Andrea P.
                  </p>
                  <p className="text-gray-500 font-body text-xs m-0" data-id="element-326">
                    35 años, Tucumán
                  </p>
                </div>
              </div>
            </div>
          </SectionReveal>
        </div>
      </div>
    </section>;
}